import React from 'react'
import {
  Checkbox,
  IconPathfinderMinusFront,
  Flex,
  SpacingVertical,
  SPACING_8,
  Divider,
  Text,
  TEXT_VARIANT_LIGHT,
  TruncateAndTooltip
} from 'mailup-web-components'
import CheckItem from 'Components/CheckItem/CheckItem'

import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

export const SECTION = {
  body: 'BODY',
  subject: 'SUBJECT',
  preheader: 'PREHEADER'
}

const DynamicFieldItem = ({
  items,
  title,
  description,
  section,
  setModalState,
  addToWhiteList,
  checkSummary = false,
  icon,
  alert,
  callbackAlert,
  callbackSaveItems,
  badge
}) => {
  // at least one section must set a title
  const props = () => ({
    itemKey: `item-${section}`,
    icon: title !== '' ? icon : undefined,
    alert: title !== '' ? alert : undefined,
    callbackAlert: callbackAlert,
    title: title,
    description: description,
    badge: title !== '' ? badge : undefined,
    'data-mu-test': 'potential-details__dynamic-fields-warning--ko'
  })

  return (
    <>
      <CheckItem {...props()} />
      <div className='dynamic-field-item--container'>
        <Flex flexDirection='column' margin='0 0 0 32px'>
          {items.map((e, i) => {
            return (
              <>
                {i === 0 && <SpacingVertical variant={SPACING_8} />}
                <StyledFlex
                  padding='8px 8px 8px 0'
                  justifyContent='space-between'
                  key={`${e.Value}_${i}`}
                  data-mu-test={`overview-message__dynamic-field-item-${section}-child-${e.Value}`}
                  columnGap='8px'
                >
                  <Flex alignItems='center' columnGap='8px' minWidth='0'>
                    <StyledIcon />
                    <StyledField
                      variant={TEXT_VARIANT_LIGHT}
                      htmlElement='span'
                    >
                      {e.Value}
                    </StyledField>
                  </Flex>
                  <WarningCheckbox
                    item={e}
                    setModalState={setModalState}
                    addToWhiteList={addToWhiteList}
                    checkSummary={checkSummary}
                    callbackSaveItems={callbackSaveItems}
                  />
                </StyledFlex>
                {i !== items.length - 1 && <Divider />}
              </>
            )
          })}
        </Flex>
      </div>
    </>
  )
}

const WarningCheckbox = ({
  item,
  addToWhiteList,
  setModalState,
  checkSummary,
  callbackSaveItems
}) => {
  const intl = useIntl()
  const handleCheckChange = async () => {
    const value = item.Value.replace(/[[\]]/g, '')

    const newItems = s => {
      const resItems = addToWhiteList.slice(0)
      const index = resItems.findIndex(e => e === value)
      if (index > -1) {
        resItems.splice(index, 1)
      } else {
        resItems.push(value)
      }
      return resItems
    }
    await setModalState(prev => ({
      ...prev,
      addToWhiteList: newItems(prev.addToWhiteList)
    }))
    if (callbackSaveItems) {
      callbackSaveItems()
    }
  }

  return (
    <Flex minWidth='40%' justifyContent='flex-end'>
      <Checkbox
        onChange={handleCheckChange}
        value={item.Value}
        checked={
          addToWhiteList.findIndex(
            e => e === item.Value.replace(/[[\]]/g, '')
          ) > -1
        }
        data-mu-test={'overview-message__check_' + item.Value}
      />
      <StyledText
        variant={TEXT_VARIANT_LIGHT}
        htmlElement='span'
        onClick={handleCheckChange}
      >
        {intl.formatMessage({
          id: 'Load.EmailCheckUp.NotWarnAnymore'
        })}
      </StyledText>
    </Flex>
  )
}

DynamicFieldItem.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
  description: PropTypes.any,
  section: PropTypes.string,
  setModalState: PropTypes.func,
  addToWhiteList: PropTypes.any,
  checkSummary: PropTypes.bool,
  icon: PropTypes.any,
  alert: PropTypes.any,
  callbackAlert: PropTypes.func,
  callbackSaveItems: PropTypes.func,
  badge: PropTypes.string
}
WarningCheckbox.propTypes = {
  item: PropTypes.any,
  addToWhiteList: PropTypes.func,
  setModalState: PropTypes.func,
  checkSummary: PropTypes.bool,
  callbackSaveItems: PropTypes.func
}

export default DynamicFieldItem

const StyledIcon = styled(IconPathfinderMinusFront)`
  color: var(--sunset-orange);
  font-size: 13px;
  align-self: flex-start !important;
`

const StyledText = styled(Text)`
  :hover {
    cursor: pointer;
  }
`

const StyledField = styled(Text)`
  word-break: break-all !important;
`

const StyledFlex = styled(Flex)`
  :hover {
    background-color: var(--wild-sand);
  }
`
